module.exports = __webpack_public_path__ + "img/om_qr_pdd.36e9bd7f.png";